import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { CardSelector } from '../shared/card-selector';
import { UploadCard } from '../shared/upload-card';
import { useEditorContext } from '../../context/editor-context';
import { useAssetUploadHandler } from '../../hooks/use-asset-upload-handler';
import { getVestuariosByAmbiente, getVestuarioPreviewForAmbiente } from '../../utils/avatar-lookups';
import { capitalize } from '../../../../utils/capitalze';

const UPLOAD_DISABLED = true;

/**
 * Vestuario section — segundo nivel del selector encadenado.
 * Muestra vestuarios disponibles filtrados por el ambiente seleccionado.
 * Solo se renderiza si hay un ambiente elegido.
 */
export const VestuarioSection: React.FC = () => {
  const { scene, activeIndex, updateScene } = useEditorContext();
  const { handleAvatarUpload, isUploading, uploadProgress } = useAssetUploadHandler();

  if (!scene.ambiente) return null;

  const vestuarios = getVestuariosByAmbiente(scene.ambiente);

  const options = vestuarios.map(v => ({
    id: v,
    label: capitalize(v),
    imageUrl: getVestuarioPreviewForAmbiente(v, scene.ambiente)
  }));

  const handleChange = (id: string) => {
    if (id !== scene.vestuario) {
      updateScene(activeIndex, 'plano', 'medio');
    }
    updateScene(activeIndex, 'vestuario', id);
  };

  return (
    <CardSelector
      label='Vestuario'
      icon={<UserOutlined />}
      options={options}
      value={scene.vestuario}
      onChange={handleChange}
      extra={
        !UPLOAD_DISABLED ? (
          <UploadCard isUploading={isUploading} uploadProgress={uploadProgress} onUpload={handleAvatarUpload} />
        ) : undefined
      }
    />
  );
};
